<section>
    <div class="xmc-consent-page">
        <h2 class="title">{{ xmcConsentPageData.header }}</h2>
        <p class="description">{{ xmcConsentPageData.body }}</p>

        <div class="features">
            <h2 class="feature-header">{{ xmcConsentPageData.features.header }}</h2>
            <ul>
                <li *ngFor="let item of xmcConsentPageData.features.items">{{ item }}</li>
            </ul>
            <a class="protection-link" [uiSref]="'account.devices.details.protection'"
                [uiParams]="{ line_id: xmcConsentPageData.devices.items[0].lineIdKey, device_id: xmcConsentPageData.devices.items[0].deviceIdKey }">
                {{ xmcConsentPageData.features.supportLinkContent }}
            </a>
        </div>

        <div class="devices">
            <h3 class="device-header">{{ xmcConsentPageData.devices.header }}</h3>
            <div class="devices-container" *ngIf="xmcConsentPageData?.devices?.items?.length > 0">
                <xm-consent-devices-card 
                    *ngFor="let device of xmcConsentPageData.devices.items; let i = index" 
                    [device]="device"
                    [index]="i"
                    [initialValue]="false"
                    [isSelectable]="true"
                    (selectionChange)="onDeviceSelectionChange($event)">
                </xm-consent-devices-card>
            </div>
            <div class="consent-checkbox-container">
                <input name="confirmation" id="confirmation" class="checkbox" type="checkbox" role="checkbox" [checked]="consentAgreed"
                    (change)="toggleCheckboxSelection()" xmAriaCheckbox [isInputChecked]="consentAgreed" />
                <label for="confirmation">
                    <xm-checkbox [isSelected]="consentAgreed"></xm-checkbox>
                </label>
                <cms-text class="confirmation-text" [originalText]="xmcConsentPageData.devices.consentContent"></cms-text>
            </div>
            <div class="consent-actions">
                <button class="xm-btn-link-light btn secondary-btn" (click)="onBack()">{{ xmcConsentPageData.devices.cancelCta }}</button>
                <button class="xm-btn-primary-light promise-btn" [disabled]="!consentAgreed" [ngClass]="{ 'disabled': !consentAgreed }" (click)="onContinue()">
                    {{ xmcConsentPageData.devices.continueCta }}
                </button>
            </div>
        </div>
    </div>
</section>
